import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncExportDialog = Loadable({
  loader: () => import( /* webpackChunkName: "export-dialog" */'ExportDialog/modal/ExportDialog')
});
export default AsyncExportDialog;